export default "__VITE_ASSET__HwdeQj6t__"